import * as React from 'react';
import { Common } from './Common'

declare var Songtive: Songtive;
interface Songtive {
    Services: any;
}

const styles = {
    bottomPadding: {
        margin: '0px 0px 10px 0px'
    },
    centerAlignment : {
        position: "relative",
        top: '50%',
        WebkitTransform: 'translateY(-50%)',
        msTransform: 'translateY(-50%)',
        transform: 'translateY(-50%)',
    } as React.CSSProperties,
    orRow : {
        height : '36px'
    }
};

const PIANO_MODE = 1;
const GUITAR_MODE = 2;

export default class ChordsList extends React.Component<any, any> {

    chords : Array<any>;
    instrument_mode : Number;

    constructor(props : any) {
        super(props);

        this.state = Object.assign({mode : 'NAMES'}, Object.keys(props).length > 0 ? this.props : window.initialState);
        this.instrument_mode = (this.state.tuning ? GUITAR_MODE : PIANO_MODE);
        this.chords = this.state.chords;
    }

    renderNotes (className, root) {
        let activeClass = "";
        if (root.url === this.state.selectedRootUrl)
            activeClass = " active";

        return <a href={this.state.url + root.url} key={root.url} className={`btn ${className} ${activeClass} no-uppercase`}>{root.name}</a>
    }

    initService () {
        if (!window.app.ChordService)
            window.app.ChordService = new Songtive.Services.ChordService(null, null);

        Songtive.Services.NoteService.setNotationByLanguage(this.state.lang)
    }

    transformToAscii (t) {
        t = Songtive.Services.NoteService.notesToAscii(t);
        t = t.replace("|", "")
        .replace("\u00B0", "o")
        return t;
    }

    searchChangedHandler (event) {
        let value = event.target.value.trim();

        if (value.length > 0)
        {
            this.initService();

            let chords = window.app.ChordService.findChordsByName(value);
            let notes = Songtive.Services.NoteService.parseSemitones(value);
            if (chords.length > 0) {
                window.app.gaEvent("search_chord", null, value);
                this.setState({chords: chords, notes: notes, mode: 'CHORDS'});
                return;
            }
        }

        // fallback to simple search by name

        let regex = new RegExp(Common.escapeRegExp(Songtive.Services.NoteService.notesToAscii(value)), 'i');

        const chords = this.chords.filter((c) => {
            let r = c.names.filter(t => regex.test(this.transformToAscii(t)));
            if (r.length > 0) return true;
            if (c.longNames) {
                return c.longNames.filter(t => regex.test(this.transformToAscii(t))).length > 0;
            }
            return false;
        });


        window.app.gaEvent("search_chord2", null, value + "=" + chords.length);

        if (chords.length == 0)
            window.app.gaEvent("search_chords_noresults", null, value);

        this.setState({chords : chords, mode : 'NAMES', last_search : value});
    }

    searchByNoteChangedHandler (event) {
        this.initService();

        let value = event.target.value.trim();
        if (value == '') {
            this.searchChangedHandler (event);
            return;
        }
        let notes = Songtive.Services.NoteService.parseSemitones(value);
        let chords = window.app.ChordService.findChordsBySemitones(notes);

        this.setState({chords : chords.toArray(), notes : notes, mode : 'CHORDS'});
    }

    drawNames() {
        const chords = this.state.chords.map((chord, i) => {
            let activeClass = "";
            if (i === this.state.selectedChordId)
                activeClass = " active";

            let name = (this.state.semitoneName ? this.state.semitoneName : this.state.root) + chord.names[0].replace(/\|(.*)/, '<sup>$1</sup>');

            return <a href={this.state.url + chord.url} key={chord.id} className={`btn btn-default seo-chords${activeClass}`} dangerouslySetInnerHTML={{__html : name}} />

        });

        const defaultNotes = this.state.defaultNotes.map((o, i) => this.renderNotes('btn-default', o));
        const sharpNotes = this.state.sharpNotes.map((o, i) => this.renderNotes('btn-info', o));
        const flatNotes = this.state.flatNotes.map((o, i) => this.renderNotes('btn-primary', o));

        if (chords.length == 0)
            return <div></div>

        return <div>
            <p>
                or select the root of the chord
            </p>
            <div style={styles.bottomPadding} className="btn-group">
                {defaultNotes}
                {flatNotes}
                {sharpNotes}
            </div>
            <p>then select chord type (quality) from the list below</p>
            <div style={styles.bottomPadding} className="btn-group">
                {chords}
            </div>
        </div>
    }

    drawChords() {
        const chords = this.state.chords.map((chord, i) => {
            let activeClass = "";
            let descriptor = null;
            if (chord.getDescriptor)
                descriptor = chord.getDescriptor();
            else
                descriptor = chord;

            if (descriptor.getId() == this.state.selectedChordId)
                activeClass = " active";

            let name = chord.getRoot().getName() + descriptor.getNames()[0].replace(/\|(.*)/, '<sup>$1</sup>');
            if (chord.getFormula && this.state.notes.length == chord.getFormula().length)
                name = '<b>' + name + '</b>';

            return <a href={this.state.url + this.chordSpecialCharReplace(chord.getRoot().getName()) + this.chordNameToUrl(descriptor)} key={chord.getRoot().getName() + "_" + descriptor.getId()} className={`btn btn-default seo-chords${activeClass}`} dangerouslySetInnerHTML={{__html : name}} />

        });

        return <div>
            <p>then select chord from the list below</p>
            <div style={styles.bottomPadding} className="btn-group">
                {chords}
            </div>
        </div>
    }

    trackSuggestChord() {
        window.app.gaEvent("suggest_chord", null, this.state.last_search);
    }

    trackDownloadChord() {
        window.app.gaEvent("download_chord");
    }

    trackDownloadChordIQ() {
        window.app.gaEvent("download_chordiq");
    }

    render() {
        let list;
        if (this.state.mode == 'NAMES')
            list = this.drawNames();
        else
            list = this.drawChords();

        let bottomText;
        if (this.instrument_mode == PIANO_MODE)
            bottomText =
                <p>Additionally, you can <a href="http://pianocompanion.info/app/chords" onClick={this.trackDownloadChord.bind(this)}  className="btn btn-success">Download</a> our <a href="http://pianocompanion.info/app/chords">Piano Companion</a> <b>FREE</b> app which is used by millions of users worldwide and contains more than <b>10,000+</b> chords and scales.</p>
        else
            bottomText =
                <p>Additionally, you can <a href="http://chordiq.info/app/chords-guitar" onClick={this.trackDownloadChordIQ.bind(this)}  className="btn btn-success">Download</a> our <a href="http://chordiq.info/app/chords-guitar">ChordIQ</a> <b>FREE</b> to learn notes, guitar (or ukulele, bass, you name) chords in different tuning, perfect pitch and lots more.</p>

        let searchPlaceholder = `${this.state.defaultNotes[2].name}M, ${this.state.defaultNotes[0].name.toLowerCase()}sus4, Major, min, 7, Δ, m ...`
        let searchByNotePlaceholder = `${this.state.flatNotes[1].name} ${this.state.sharpNotes[2].name} ${this.state.flatNotes[5].name} ...`

        let no_result;
        if (this.state.chords && this.state.chords.length == 0)
            no_result = <p>We don't know that chord. 🥺 Feel free to <a href="mailto:chords@songtive.com?subject=New chord suggestion" onClick={this.trackSuggestChord.bind(this)} className="btn btn-warning">Suggest</a> a missing chord.</p>
        else
            no_result = '';


        return <div>
                <div style={styles.bottomPadding} className="row">
                    <div className="col-xs-5">
                        <p>
                            Search chord by name:
                        </p>
                        <div className="input-group">
                            <input type="text" id="tbSearch" className="form-control" placeholder={searchPlaceholder} onChange={this.searchChangedHandler.bind(this)} />
                            <span className="input-group-btn">
                                <button className="btn btn-default" type="button">Search</button>
                            </span>
                        </div>
                    </div>
                    <div className="col-xs-1">
                        <p>&nbsp;</p>
                        <div className="col-xs-12" style={styles.orRow}>
                            <div className="text-center" style={styles.centerAlignment}>
                                OR
                            </div>
                        </div>
                    </div>
                    <div className="col-xs-6">
                        <p>
                            Search chord by notes:
                        </p>
                        <div className="input-group">
                            <input type="text" id="tbSearchByNote" className="form-control" placeholder={searchByNotePlaceholder} onChange={this.searchByNoteChangedHandler.bind(this)} />
                            <span className="input-group-btn">
                                <button className="btn btn-default" type="button">Search</button>
                            </span>
                        </div>
                    </div>
                </div>
                {list}
                {no_result}
                {bottomText}
            </div>
    }

    // HACK: extracted from chord-name-transformer.coffee
    chordNameToUrl(chord) {
        let url = chord.getLongNames() ? chord.getLongNames()[0] : chord.getNames()[0];
        url = this.chordSpecialCharReplace(url);
        return url
    }

    chordSpecialCharReplace(chordName) {
        chordName = chordName.replace("Ø", "half_diminished");
        chordName = chordName.replace("|", "");
        chordName = chordName.replace("#", "x");
        chordName = chordName.replace("♯", "x");
        chordName = chordName.replace("♭", "b");
        chordName = chordName.replace("/", "_");
        chordName = chordName.replace("b", "b");
        return chordName
    }

}


// WEBPACK FOOTER //
// ./components/common/ChordsList.tsx